@use '../../scss/utility/functions' as utility;

:host {
  display: inline-flex;
  position: relative;
  /** @prop --nav-bar-height: height of the nav bar */
  --nav-bar-height: #{utility.wb-pixel-to-rem(56px)};
}

.trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: var(--nav-bar-height);
  min-width: utility.wb-pixel-to-rem(48px);
  padding: 0 utility.wb-pixel-to-rem(24px);
  outline: none;
  color: var(--wb-grey-60);
  background: transparent;
  cursor: pointer;
  text-decoration: none;
  text-align: start;
  border: 0;
  box-sizing: border-box;
  appearance: none;
  gap: utility.wb-pixel-to-rem(8px);

  &:hover,
  &:focus-visible {
    color: var(--wb-white);
    text-decoration: none;
  }
}

:host([active]) {
  .trigger {
    color: var(--wb-white);
  }

  &::after {
    position: absolute;
    content: '';
    inset-inline-start: 0;
    inset-block-start: utility.wb-pixel-to-rem(-1px);
    width: 100%;
    height: utility.wb-pixel-to-rem(1px);
    background: var(--wb-blue-50);
    animation-duration: 0.15s;
    animation-name: slideIn;
    animation-timing-function: var(--wb-move);
    transform-origin: 0 50%;
  }
}

:host([has-icon]) .trigger {
  padding-inline-start: utility.wb-pixel-to-rem(8px);
}

::slotted(.wb-icon) {
  color: inherit;
  pointer-events: none; // preventing that it catches the click event!
  --size: #{utility.wb-pixel-to-rem(16px)};
}

::slotted(.wb-icon[name*='/']) {
  --size: #{utility.wb-pixel-to-rem(24px)};
}

@keyframes slideIn {
  0% {
    transform: scaleX(0);
  }

  100% {
    transform: scaleX(1);
  }
}
